import { normalizeBrazilianE164 } from "../../../lib/phone";

export const BOOKING_SUCCESS_EMAIL_ONLY =
  "Agendamento confirmado! Você receberá uma confirmação por e-mail.";

export const BOOKING_SUCCESS_EMAIL_AND_WHATSAPP =
  "Agendamento confirmado! Você vai receber a confirmação por e-mail e pelo WhatsApp.";

/**
 * CNF-04: a frase da tela de sucesso diz por onde a confirmação vai.
 *
 * `whatsappConfirmation` vem do perfil público da unidade
 * (`whatsappBookingConfirmation`): chave ligada, sessão utilizável e assinatura
 * ativa. Ausente vale falso, porque a rota o omite quando bloqueia.
 *
 * O número precisa ser um WhatsApp brasileiro válido pela mesma regra do envio.
 * O formulário aceita qualquer coisa com 10 dígitos, e prometer uma mensagem
 * que o backend não vai mandar é pior do que não prometer.
 */
export function bookingSuccessMessage({
  whatsappConfirmation,
  whatsapp,
}: {
  whatsappConfirmation?: boolean | null;
  whatsapp?: string | null;
}): string {
  const e164 = normalizeBrazilianE164(whatsapp);
  if (whatsappConfirmation === true && e164?.startsWith("+55")) {
    return BOOKING_SUCCESS_EMAIL_AND_WHATSAPP;
  }
  return BOOKING_SUCCESS_EMAIL_ONLY;
}
